'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESearchDataflows = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DESearchDataflows = function DESearchDataflows(_ref) {
  var rest = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(_.VXList, _extends({}, rest, { itemRenderer: _.DESearchDataflow }));
};
exports.DESearchDataflows = DESearchDataflows;


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-dataflows/index.js
// module id = 2020
// module chunks = 0